import { Column, Row } from '@/styles/common';
import { formatNum, joinClassNames } from '@/utils/utils';
import React, { useEffect, useState } from 'react';

interface NumFieldProps extends INullableField<number> {
	scale?: number;
	isPct?: boolean;
	round?: boolean;
}

const NumField: React.FC<NumFieldProps> = ({
	value,
	setValue,
	scale = 0,
	disabled,
	label,
	isPct = false,
	round = false,
	...props
}) => {
	const [state, setState] = useState('');

	useEffect(() => {
		if (value !== null && value !== undefined && typeof value !== 'number') {
			setValue?.(null);
		} else {
			setState(formatNum({ value, scale, round }));
		}
	}, [value]);

	const onBlur =
		setValue && !disabled
			? () => {
					const formattedValue = parseFloat(state.replaceAll(' ', ''));
					formattedValue !==
						parseFloat(
							formatNum({ value, scale, round, formatThousands: false })
						) &&
						!isNaN(formattedValue) &&
						setValue(formattedValue);
			  }
			: undefined;

	const onChange = !disabled
		? (e: React.ChangeEvent<HTMLInputElement>) => {
				if (!/^-?\d*(?:[,.]?\d*)?$/.test(e.target.value.replaceAll(' ', ''))) {
					e.preventDefault();
					return;
				}

				const formattedValue = e.target.value.replaceAll(',', '.');
				setState(formattedValue);
		  }
		: undefined;

	const onKeyDown = !disabled
		? (e: React.KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					onBlur?.();
				}
		  }
		: undefined;

	const _disabled = !setValue || disabled;

	return (
		<Column>
			{label && <label>{label}</label>}
			<Row>
				<div style={{ position: 'relative', flex: 1 }}>
					<input
						{...props}
						value={state}
						onBlur={onBlur}
						onChange={onChange}
						onKeyDown={onKeyDown}
						disabled={_disabled}
						style={{
							textAlign: 'right',
							paddingRight: isPct ? '15px' : '0px',
						}}
					/>
					{isPct && (
						<span
							className={joinClassNames(_disabled && 'disabled')}
							style={{
								position: 'absolute',
								right: '2px',
								top: '7px',
								fontSize: '0.8em',
							}}>
							%
						</span>
					)}
				</div>
			</Row>
		</Column>
	);
};

export default NumField;
